<template>
  <div
    class="py-2 text-dark section section--border-top bg-green lg:py-4"
    id="training-suggestions"
  >
    <div class="container">
      <div class="container__inner px-1.5">
        <div class="flex items-center section-title">
          <svg
            width="20"
            height="20"
            class="text-dark fill-current mr-0.5 h-0.625 w-0.625 lg:h-1.25 lg:w-1.25"
          >
            <use xlink:href="#icon-circle" />
          </svg>
          <h2 class="text-sm uppercase lg:text-base">
            Ces formations pourraient vous intéresser
          </h2>
        </div>
        <!-- .section-title -->
        <div class="py-4 training-slider">
          <div class="flex flex-wrap justify-between">
            <div class="w-full lg:w-10/12">
              <div class="swiper">
                <swiper-container
                  id="swiper-training-suggestions"
                  :uniqueNavElements="false"
                  class="swiper-wrapper"
                  :slides-per-view="1"
                  :breakpoints="{
                    900: { slidesPerView: trainings.length > 1 ? 2 : 1 },
                  }"
                  :navigation="{
                    nextEl: '#training-suggestions .swiper-button-next',
                    prevEl: '#training-suggestions .swiper-button-prev',
                  }"
                >
                  <swiper-slide
                    class="training--item swiper-slide"
                    v-for="training in trainings"
                  >
                    <div class="list_item px-1.25 lg:px-3 mb-2 relative">
                      <div class="pb-1 pr-3 entry-meta lg:pr-0 lg:pb-0">
                        <ul class="flex flex-wrap items-center unstyled">
                          <li class="pr-0.5 pb-1" v-if="training.type">
                            <span
                              class="bg-dark border border-solid border-dark inline-flex items-center font-medium p-0.5 text-xs lg:text-sm uppercase no-underline text-white border-radius-small"
                            >
                              {{ training.type }}
                            </span>
                          </li>

                          <li class="pr-0.5 pb-1">
                            <span
                              class="border border-solid border-dark inline-flex items-center font-medium p-0.5 text-xs lg:text-sm uppercase no-underline text-dark border-radius-small"
                            >
                              {{ training.category }}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <!-- .entry-meta -->
                      <a
                        :href="training.permalink"
                        class="block no-underline text-dark"
                      >
                        <p class="p-0 m-0 text-xl leading-tight text-dark">
                          {{ training.title }}
                        </p>
                      </a>
                      <span
                        class="block pt-1 text-base leading-normal"
                        v-html="training.excerpt"
                      >
                      </span>
                      <ul
                        class="list-none m-0 p-0 pt-1.25 lg:pt-1.75 flex items-center flex-wrap"
                      >
                        <li class="flex items-center pb-1 pr-1">
                          <svg
                            width="8"
                            height="8"
                            class="text-dark fill-current mr-0.5 h-0.5 w-0.5"
                          >
                            <use xlink:href="#icon-circle" />
                          </svg>
                          <span class="text-sm">{{ training.level }}</span>
                        </li>
                        <li class="flex items-center pb-1 pr-1">
                          <svg
                            width="8"
                            height="8"
                            class="text-dark fill-current mr-0.5 h-0.5 w-0.5"
                          >
                            <use xlink:href="#icon-circle" />
                          </svg>
                          <span class="text-sm">{{ training.duration }}</span>
                        </li>
                        <li class="flex items-center pb-1 pr-1">
                          <svg
                            width="8"
                            height="8"
                            class="text-dark fill-current mr-0.5 h-0.5 w-0.5"
                          >
                            <use xlink:href="#icon-circle" />
                          </svg>
                          <span class="text-sm">{{ training.price }}</span>
                        </li>
                      </ul>

                      <button
                        class="absolute top-0 z-10 inline-flex items-center justify-center w-3 h-3 rounded right-1 bt-favorite bg-dark"
                        :class="{ favorited: training.favorite }"
                        @click="toggleFavorite(training)"
                      >
                        <HeartIcon
                          class="w-1.5 h-1.5 flex-shrink-0 text-white stroke-current fill-none fillable"
                        />
                        <span class="visuallyhidden">Ajouter aux favoris</span>
                      </button>
                    </div>
                    <!-- .list_item -->
                  </swiper-slide>
                  <!-- . swiper-slide -->
                </swiper-container>
                <!-- .swiper-wrapper -->
              </div>
              <!-- .swiper -->
            </div>

            <div
              class="flex items-center w-full lg:w-2/12"
              v-if="trainings.length > 1"
            >
              <div
                class="relative flex flex-row items-center justify-center w-full quiz-slider__toolbar lg:flex-col"
              >
                <div
                  class="after:content-none swiper-button-prev border border-solid border-dark rounded flex items-center justify-center h-3 w-3 lg:h-4.5 lg:w-4.5 m-1 rotate-90 text-dark relative left-0"
                >
                  <CaretIcon class="w-1.5 h-1.5 stroke-current" />
                </div>
                <div
                  class="after:content-none swiper-button-next border border-solid border-dark rounded flex items-center justify-center h-3 w-3 lg:h-4.5 lg:w-4.5 m-1 -rotate-90 text-dark relative left-0"
                >
                  <CaretIcon class="w-1.5 h-1.5 stroke-current" />
                </div>
              </div>
              <!-- .quiz-slider__toolbar -->
            </div>
          </div>
          <!-- .flex -->
        </div>
        <!-- .quiz-slider -->
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { ref } from "vue";
import { HeartIcon } from "@heroicons/vue/20/solid";
import CircleIcon from "./icons/CircleIcon.vue";
import CaretIcon from "./icons/CaretIcon.vue";

const props = defineProps({
  trainings_ids: {
    type: Array,
    required: true,
  },
  userId: {
    type: Number,
    required: true,
  },
});
const trainings = ref([]);
const fetchTrainings = () => {
  const response = fetch(
    `${
      import.meta.env.VITE_QUIZ_API_ENDPOINT
    }/trainings/?ids=${props.trainings_ids.join(",")}&user_id=${props.user_id}`
  )
    .then((response) => response.json())
    .then((data) => {
      trainings.value = data;
    });
};
fetchTrainings();

const toggleFavorite = (training) => {
  fetch(`${import.meta.env.VITE_QUIZ_API_ENDPOINT}/favorite/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      user_id: props.userId,
      training_id: training.id,
    }),
  })
    // .then((r) => r.json())
    .then((r) => {
      console.log(r);
      training.favorite = !training.favorite;
    })
    .catch((error) => {
      console.log(error);
      training.favorite = !training.favorite;
    });
};
</script>
